import { ErrorBoundary } from 'react-error-boundary'
import { useLocation, useParams } from 'react-router-dom'
import { Layout } from 'antd'

import ErrorFallback from 'src/modules/layouts/ErrorFallback'
import BonLookFooter from 'src/modules/layouts/footer/BonLookFooter'
import LayoutPlain from 'src/modules/layouts/LayoutPlain'
import LayoutWithSections from 'src/modules/layouts/LayoutWithSections'
import {
  balanceDue,
  orderRMA,
  ordersDetailsMissingPD,
  ordersDetailsMissingRx,
  ordersDetailsMissingRxOption,
  paymentSuccess,
  prescriptionDetailsUpload,
  prescriptionDetailsUploadLinkedAccounts,
  prescriptionDetailsUploadOption,
  prescriptionDetailsUploadOptionLinkedAccounts,
  pupillaryDistanceDetailsUpload,
} from 'src/routes/NamedRoutes'
import { isMobile } from 'src/utils/helper'

import './DefaultLayout.less'

const DefaultLayout = (): JSX.Element => {
  const location = useLocation()
  const { option, orderId, customerId } = useParams()
  let isPagesWithoutSections = false
  let formattedUrls = [
    pupillaryDistanceDetailsUpload,
    prescriptionDetailsUpload,
    prescriptionDetailsUploadLinkedAccounts,
    prescriptionDetailsUploadOption,
    prescriptionDetailsUploadOptionLinkedAccounts,
    ordersDetailsMissingPD,
    ordersDetailsMissingRx,
    ordersDetailsMissingRxOption,
    orderRMA,
    balanceDue,
    paymentSuccess,
  ]
  if (orderId) {
    formattedUrls = formattedUrls.map((url) => url.replace(':orderId', orderId))
  }
  if (option) {
    formattedUrls = formattedUrls.map((url) => url.replace(':option', option))
  }
  if (customerId) {
    formattedUrls = formattedUrls.map((url) => url.replace(':customerId', customerId))
  }
  isPagesWithoutSections = formattedUrls.includes(location.pathname)

  return (
    <>
      <Layout className="default-layout">
        <ErrorBoundary
          key={window.location.href}
          FallbackComponent={ErrorFallback}
        >
          {isPagesWithoutSections ? <LayoutPlain /> : <LayoutWithSections />}
        </ErrorBoundary>
        {!isMobile() && <BonLookFooter />}
      </Layout>
    </>
  )
}

export default DefaultLayout
